/**
 * Utility to filter guidelinename and topicname from search results URL, clean them for send to GA4
 * @param {string} url - The URL to parse
 * @returns {object} - Object containing cleaned guidelinePage and topicFile
 */
export function extractGuidelineName(url) {
    try {
        const queryString = url.includes('?') ? url.split('?')[1] : '';
        const params = new URLSearchParams(queryString);
        const guideline = params.get('guidelinePage');

        // Clean function: decode URI components, replace special chars, trim
        const cleanText = (guideline) => {
            if (!guideline) return '';

            return decodeURIComponent(guideline)
                .replace(/\s+/g, ' ')
                .trim();
        };

        return {
            guidelineName: cleanText(guideline),
        };

    } catch (error) {
        console.error('Error parsing URL:', error);
        return {
            guidelineName: '',
        };
    }
};